module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/bcce426540912efc60873a456355f094.png";